import RejectedSvg from "@assets/pictures/rejected.svg";
import { useI18n } from "@core/i18n/i18n";
import { analyticsService, userManager } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import styled from "@emotion/styled";
import { AppLogo } from "@ui/components/common/app-logo";
import { Button } from "@ui/components/buttons/button";
import { LoginContainer } from "@ui/components/login/login-container";
import { useCountryConfig } from "@ui/pages/patient-details/hooks/use-country-config";
import { stack } from "@ui/style";
import React from "react";

export default function RejectedPtPage(): JSX.Element {
	return <LoginContainer form={<RejectedPtCard />} />;
}

const RejectedPtCard = (): JSX.Element => {
	const { format } = useI18n();
	const { countryConfig } = useCountryConfig();

	return (
		<MainContainer>
			<StyledAppLogo height={42} width={211} />
			<RejectedImg height={180} width={180} />
			<Title>{format("register.rejected-pt.title")}</Title>
			<Subtitle className="p-size-m">{format("register.rejected-pt.subtitle")}</Subtitle>
			<StrechButton
				onClick={() => {
					analyticsService.trackEvent({ category: AnalyticsCategory.COMMUNICATION, action: "contactCustomerSupport" });
					window.open(`mailto:${countryConfig?.customerSupportEmail}`);
				}}
				label={format("register.rejected-pt.contact-button")}
			/>
			<Logout className="p-size-s" onClick={() => userManager.logout()}>
				{format("register.rejected-pt.logout")}
			</Logout>
		</MainContainer>
	);
};

const MainContainer = styled.div`
	${stack(undefined, "spacebetween", "center")}
`;

const Title = styled.h1`
	margin-bottom: 24px;
`;

const StyledAppLogo = styled(AppLogo)`
	justify-self: center;
`;

const RejectedImg = styled(RejectedSvg)`
	justify-self: center;
`;

const Subtitle = styled.div`
	margin-bottom: 24px;
`;

const StrechButton = styled(Button)`
	align-self: stretch;
`;

const Logout = styled.div`
	margin-top: 12px;
	cursor: pointer;
	text-align: center;
`;
